import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../auth/AuthProvider';
import { updateProfile, validatePhone } from '../../controllers/user';
import { getToastErrorMessage } from "../../controllers/utils";
import { useToast } from '../toast/ToastContext';
import { ConfirmProceedModal } from '../ConfirmProceedModal';

const PerfilMatrimonioForm = forwardRef((props, ref) => {
  const showToast = useToast();
  const [nombreEsposo, setNombreEsposo] = useState(props.perfil?.nombre1 || '');
  const [nombreEsposa, setNombreEsposa] = useState(props.perfil?.nombre2 ||'');
  const [apellido, setApellido] = useState(props.perfil?.apellido || '');
  const [telefono1, setTelefono1] = useState(props.perfil?.telefono1 || '');
  const [telefono2, setTelefono2] = useState(props.perfil?.telefono2 || '');
  const { token } = useAuth();
  const [showProceedModal, setShowProceedModal] = useState(false);

  useImperativeHandle(ref, () => ({
    getPerfil() {
      return generatePerfil();
    }
  }));

  useEffect(() => {
    if (!props.perfil.telefono1) {
      checkPhoneNumber(telefono1);
    }
  }, [telefono1]);
  useEffect(() => {
    if (!props.perfil.telefono2) {
      checkPhoneNumber(telefono2);
    }
  }, [telefono2]);

  async function checkPhoneNumber(telefono) {
    if (telefono && telefono.length === 10) {
      try {
        const r = await validatePhone(telefono);
        if (!r.valid) {
          // Show Modal asking for confirmation message just in case the user
          // does not have a phone number and uses the number of another user.
          setShowProceedModal(r.email);
        }
      }
      catch (e) {
      }
    }
  }

  function handleChange(e) {
    const value = e.target.value;
    switch (e.target.name) {
      case 'nombreEsposo': setNombreEsposo(value); break;
      case 'nombreEsposa': setNombreEsposa(value); break;
      case 'apellido': setApellido(value); break;
      case 'telefono1': setTelefono1(value); break;
      case 'telefono2': setTelefono2(value); break;
    }
  }

  function generatePerfil() {
    return {
      tipo: 'matrimonio',
      nombre1: nombreEsposo,
      nombre2: nombreEsposa,
      apellido,
      telefono1,
      telefono2
    };
  }

  async function submitUpdate() {
    let p = generatePerfil();
    console.log(p);

    try {
      let r = await updateProfile(token, props.userId, p);
      showToast({
        message: 'La información se actualizó con éxito.',
        bg: 'success', 
        autohide: true,
        delay: 7000,
        title: 'Información actualizada'
      });
    }
    catch (e) {
      console.log(e);
      let errorMessage = e.message || 'Ocurrió un error al guardar la información. Intenta de nuevo más tarde.';
      if (e.errors) {
        errorMessage = getToastErrorMessage('Ocurrió un error al guardar la información.', e.errors);
      }
      showToast({
        message: errorMessage,
        bg: 'danger',
        autohide: true,
        delay: 7000,
        title: 'Error'
      });
    }
  }

  function renderSaveButton() {
    if (props.updateProfile) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-perfil' type='submit' variant='primary' onClick={submitUpdate}>Actualizar perfil</Button>
      </Form.Group>;
    }
  }

  return <Row>
    <Col>
      <Form.Group className="mb-3">
        <Form.Label>Nombre del esposo</Form.Label>
        <Form.Control type="text" placeholder="Nombre del esposo" name='nombreEsposo' value={nombreEsposo} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Nombre de la esposa</Form.Label>
        <Form.Control type="text" placeholder="Nombre de la esposa" name='nombreEsposa' value={nombreEsposa} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Apellido</Form.Label>
        <Form.Control type="text" placeholder="Apellido" name='apellido' value={apellido} onChange={handleChange} required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Teléfono Esposo</Form.Label>
        <Form.Control type="tel" placeholder='Teléfono Esposo' name='telefono1' value={telefono1} onChange={handleChange} pattern='\d{10}' title='Formato 1234567890' required />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Teléfono Esposa</Form.Label>
        <Form.Control type="tel" placeholder="Teléfono Esposa" name='telefono2' value={telefono2} onChange={handleChange} pattern='\d{10}' title='Formato 1234567890' required />
      </Form.Group>

      {renderSaveButton()}
    </Col>
    <ConfirmProceedModal
      show={!!showProceedModal}
      title="Número de teléfono ya registrado"
      body={<>
        <p>El número de teléfono que ingresaste ya está registrado en otra cuenta con este email: </p>
        <p><b>{showProceedModal}</b></p>
        <p>Si este número no te pertenece, por favor corrígelo.</p>
        <p>¿Deseas continuar de todas formas?</p>
        <p>Si este es tu número y tu email, entonces mejor continúa aquí:</p>
        <p className='text-center'><Button variant="primary" href='/login'>Iniciar Sesión</Button></p>
      </>}
      handleClose={() => setShowProceedModal(false)}
      cancelarText='Continuar'
    />
  </Row>;
});

export default PerfilMatrimonioForm;